import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../../constants';
import { GOOGLE_PAY } from '../../../../constants/paymentMethods';

import SvgComponent from '../../../SvgComponent';

import './GooglePayStyle.scss';

const GooglePay = ({ selectedMethod, handleMethodChange, i18n }) => {
    return (
        <div id="google-pay-container" onClick={() => handleMethodChange(GOOGLE_PAY)}>
            <div>
                <input
                    type="radio"
                    id="google-pay"
                    name="google-pay"
                    value={GOOGLE_PAY}
                    checked={selectedMethod === GOOGLE_PAY}
                />

                <label htmlFor="google-pay">{i18n.PAYMENT_CHOICE.GOOGLE_PAY}</label>
            </div>
            <SvgComponent
                src={`${STATIC_ROOT}/payment/google-pay.svg`}
                className="haut"
                width="50"
                height="27"
            />
        </div>
    );
};

GooglePay.propTypes = {
    selectedMethod: PropTypes.string,
    handleMethodChange: PropTypes.func
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON
    };
};

export default connect(mapStateToProps)(GooglePay);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/GooglePay.js